import { Outlet } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from '../Footer';
import './Outline.css';

interface OutlineProps {
  customComponent?: React.ReactNode;
}

const Outline: React.FC<OutlineProps> = ({ customComponent = undefined }) => {
  return (
    <div className="outline">
      <Navbar customComponent={customComponent} />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Outline;
